import React, {Component} from 'react'
import Observer from 'react-intersection-observer'
import styles from './ListFiltered.css'
import {Icon, LIB} from "../../constants/consts-types"
import PropTypes from "prop-types"
import Svg from "../Svg/Svg"

class ButtonLoadMore extends Component {
  static propTypes = {
    items: PropTypes.array,
    showButtonLoadMore: PropTypes.bool.isRequired,
    isLoadingMoreItems: PropTypes.bool.isRequired,
    autoLoadMore: PropTypes.func.isRequired,
    onNextPage: PropTypes.func.isRequired
  }

  render() {
    const {
      items,
      showButtonLoadMore,
      isLoadingMoreItems,
      autoLoadMore,
      onNextPage
    } = this.props

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <div className={styles.loadMoreContainer}>
                {showButtonLoadMore &&
                <Observer onChange={autoLoadMore}>
                  {({inView, ref}) => (
                    <button
                      ref={ref}
                      aria-label={LIB.load_more}
                      className={styles.btnLoadMore}
                      onClick={onNextPage}
                      disabled={isLoadingMoreItems}
                    >
                      <Svg id={Icon.PLUS} className={isLoadingMoreItems ? styles.plusLoading : styles.plus}/>
                    </button>
                  )}
                </Observer>
                }
              </div>
            </div>
          </div>
        </div>

        {Boolean(!items || !items.length) &&
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <p>{`${LIB.no_items_found}`} </p>
            </div>
          </div>
        </div>
        }
      </React.Fragment>
    )
  }
}

export default ButtonLoadMore



// WEBPACK FOOTER //
// ./src/components/ListFiltered/ButtonLoadMore.js